export default __webpack_public_path__ + "static/media/IconLocationMap.b814588b.png";